import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { Box, Typography, TextField, Button, List, ListItem, ListItemText, Divider } from '@mui/material';
import './GuestBook.css';

const GuestBook = () => {
  const [name, setName] = useState('');
  const [message, setMessage] = useState('');
  const [messages, setMessages] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  // Fetch messages from the API when the component mounts
  useEffect(() => {
    const fetchMessages = async () => {
      try {
        const response = await axios.get('/api/guestbook');
        setMessages(response.data); // Set messages from the API
      } catch (err) {
        setError('Failed to load messages. Please try again later.');
      } finally {
        setLoading(false);
      }
    };

    fetchMessages();
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!name || !message) {
      setError('Name and message are required.');
      return;
    }

    try {
      const newMessage = { name, message };

      // Send the new message to the API
      const response = await axios.post('/api/guestbook', newMessage);

      // Add the new message to the UI (optimistic update)
      setMessages([response.data, ...messages]);

      // Clear the input fields
      setName('');
      setMessage('');
    } catch (err) {
      setError('Failed to submit your message. Please try again.');
    }
  };

  return (
    <Box className="guestbook-section">
      <Typography variant="h4" className="guestbook-title">
        Virtual Guest Book
      </Typography>
      <Typography variant="body1" className="guestbook-subtitle">
        Leave a message for the happy couple!
      </Typography>

      {/* Error Handling */}
      {error && (
        <Typography variant="body2" color="error" className="guestbook-error">
          {error}
        </Typography>
      )}

      {/* Guest Book Form */}
      <form onSubmit={handleSubmit} className="guestbook-form">
        <TextField
          label="Your Name"
          variant="outlined"
          value={name}
          onChange={(e) => setName(e.target.value)}
          fullWidth
          className="guestbook-input"
          margin="normal"
        />
        <TextField
          label="Your Message"
          variant="outlined"
          value={message}
          onChange={(e) => setMessage(e.target.value)}
          fullWidth
          multiline
          rows={4}
          className="guestbook-input"
          margin="normal"
        />
        <Button type="submit" variant="contained" color="primary" className="guestbook-submit">
          Submit
        </Button>
      </form>

      {/* Messages List */}
      <Box className="guestbook-messages">
        <Typography variant="h5" className="guestbook-messages-title">
          Messages
        </Typography>

        {/* Loading Spinner */}
        {loading ? (
          <Typography>Loading messages...</Typography>
        ) : (
          <List>
            {messages.map((msg, index) => (
              <React.Fragment key={index}>
                <ListItem alignItems="flex-start">
                  <ListItemText
                    primary={msg.name}
                    secondary={msg.message}
                    className="guestbook-message"
                  />
                </ListItem>
                {index < messages.length - 1 && <Divider />}
              </React.Fragment>
            ))}
          </List>
        )}
      </Box>
    </Box>
  );
};

export default GuestBook;
